export const DEPOSIT_PROGRESS_LABELS = {
  checking: "Checking your existing notes…",
  loading: "Loading private proof data…",
  proving: "Creating your private deposit proof…",
  backup: "Saving encrypted recovery data…",
  simulation: "Checking the deposit transaction…",
  screening: "Checking wallet access…",
  wallet: "Requesting wallet approval…",
  confirming: "Waiting for confirmation…",
  verifying: "Finishing transaction…",
} as const;

export type DepositProgressStep = keyof typeof DEPOSIT_PROGRESS_LABELS;
